module.exports = __webpack_public_path__ + "img/banner01.f4c8a145.jpg";